import AutoCompleteAddress from 'app/shared/model/AutoCompleteAddress';

const AutoCompleteAddresses = ({
    addresses = [],
} = {}) => ({
    addresses: addresses.map(item => AutoCompleteAddress(item)),
});

export default AutoCompleteAddresses;
